import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { Logger } from "@iloq/shared";
import { IDeliveryType } from "@iloq/shared";

export default class DeliveryTypesApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  getDeliveryTypes(): Promise<IDeliveryType[]> {
    Logger.debug("Getting delivery types");

    const options: AxiosRequestConfig = {
      method: "get",
      url: "/api/v1/deliverytypes/get",
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("DeliveryTypesApi.getDeliveryTypes failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("DeliveryTypesApi.getDeliveryTypes result:", result);
        if (Array.isArray(result.data)) {
          return result.data as IDeliveryType[];
        }
        // case "result": "No result found"
        return [];
      });
  }
}
